import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDrag = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M3 9.2h42v4H3zM3 22h42v4H3zm0 12.8h42v4H3z" }) }) })
});
export default SvgDrag;
